import DesignTokens from '@tableau/design-tokens';
import { CheckboxMultiIconRaw } from '@tableau/icons/CheckboxMultiIcon/raw';
import { CheckboxSelectedIconRaw } from '@tableau/icons/CheckboxSelectedIcon/raw';
import { CheckboxUnselectedIconRaw } from '@tableau/icons/CheckboxUnselectedIcon/raw';
import { ReactiveRawIconRegistry } from '@tableau/icons/reactive';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-checkbox', {
    display: 'inline-block',
    verticalAlign: 'top',
    cursor: 'pointer',
    width: '15px',
    height: '15px',
    outline: 0,
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    backgroundSize: '15px 15px',
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(CheckboxUnselectedIconRaw, 16, applyColor(DesignTokens.color.elevation.border.default.medium, '#2e2e2e'))})`,
});

cssRule('.tb-checkbox:hover, .tb-checkbox:focus', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(CheckboxUnselectedIconRaw, 16, applyColor(DesignTokens.color.icon.default.default, '#2e2e2e'))})`,
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-checkbox.tb-disabled', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(CheckboxUnselectedIconRaw, 16, applyColor(DesignTokens.color.icon.default.disabled, '#c9c9c9'))})`,
    cursor: 'default',
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('.tb-checkbox.tb-checked', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(CheckboxSelectedIconRaw, 16, applyColor(DesignTokens.color.elevation.border.default.medium, '#2e2e2e'))})`,
});

cssRule('.tb-checkbox.tb-checked:hover, .tb-checkbox.tb-checked:focus', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(CheckboxSelectedIconRaw, 16, applyColor(DesignTokens.color.icon.default.default, '#2e2e2e'))})`,
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-checkbox.tb-checked.tb-disabled', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(CheckboxSelectedIconRaw, 16, applyColor(DesignTokens.color.icon.default.disabled, '#c9c9c9'))})`,
    cursor: 'default',
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('.tb-checkbox.tb-mixed', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(CheckboxMultiIconRaw, 16, applyColor(DesignTokens.color.elevation.border.default.medium, '#2e2e2e'))})`,
});

cssRule('.tb-checkbox.tb-mixed:hover, .tb-checkbox.tb-mixed:focus', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(CheckboxMultiIconRaw, 16, applyColor(DesignTokens.color.icon.default.default, '#2e2e2e'))})`,
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-checkbox.tb-mixed.tb-disabled', {
    backgroundImage: `var(${ReactiveRawIconRegistry.register(CheckboxMultiIconRaw, 16, applyColor(DesignTokens.color.icon.default.disabled, '#c9c9c9'))})`,
    cursor: 'default',
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('.tb-checkbox.tb-with-label', {
    width: 'auto',
    height: 'auto',
    paddingLeft: '21px',
    lineHeight: '15px',
});

cssRule('.tb-checkbox-site-grid-cell', {
    display: 'block',
    marginTop: '11px',
    textAlign: 'center',
});

cssRule('.taller-rows .tb-checkbox-cell', {
    width: '15px',
    height: '15px',
    paddingTop: '14px',
    paddingLeft: '14px',
    paddingBottom: '15px',
    paddingRight: '15px',
});

cssRule('.taller-rows .tb-react-dg-hcell', {
    height: '44px',
    lineHeight: '44px',
});

